import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ConfirmationService} from 'primeng/api';
import {
    ObjectBaseModeComponent
} from '../../../../../../../core/shared/object/mvs-object-base/object-base-mode.component';
import {WidgetData} from '../../../../../../../core/shared/widget/widget-data';
import {ObjectIdentifier} from '../../../../../../../core/shared/basic/object-identifier';
import {ObjectIdentifierData} from '../../../../../../../core/shared/basic/object-identifier-data';
import {FilterCriteria} from '../../../../../../../core/shared/filter/api/filter.criteria';
import {WidgetFactory} from '../../../../../../../core/shared/widget/service/widget.factory';
import {DtoDetail} from '../../../../../../../core/shared/dto/dto.detail';
import {MvsFormControlOverwrite} from '../../../../../../../core/shared/logic/form/logic/mvs-form-control-overwrite';
import {MvsFormFieldAccessEnum} from '../../../../../../../core/shared/logic/form/logic/mvs-form-field-access.enum';
import {WidgetDataParam} from '../../../../../../../core/shared/widget/widget-data-param';
import {NavigationItem} from '../../../../../../../core/shared/dto/navigation/navigation-item';
import {
    WidgetToolbarCallbackInterface
} from '../../../../../../../core/shared/widget/widget-toolbar-callback.interface';
import {Sorting} from '../../../../../../../core/shared/misc/sorting';
import {MvsCoreService} from '../../../../../../../core/shared/service/mvs-core.service';
import {MvsMessageService} from '../../../../../../../core/shared/service/message/mvs-message.service';
import {ObserverService} from '../../../../../../../core/shared/object/service/observer.service';

@Component({
    selector: 'campaign-type-config-object-component-base',
    template: '',
    standalone: false
})
export class CampaignTypeConfigObjectBaseComponent extends ObjectBaseModeComponent implements OnInit {

    objectViewWidget: WidgetData;
    objectWidget: WidgetData;

    campaignTypeConfigWidget: WidgetData;
    campaignMemberStatusTypeWidget: WidgetData;
    campaignTemplateWidget: WidgetData;

    selectedObject: ObjectIdentifier;
    isCreateMode: boolean;

    constructor(
        protected route: ActivatedRoute,
        protected coreService: MvsCoreService,
        protected messageService: MvsMessageService,
        protected confirmationService: ConfirmationService,
        protected observerService: ObserverService
    ) {
        super(route);
    }

    ngOnInit() {
        this.loadSideBarMenuItems();
        super.ngOnInit();
        this.onObjectChanged();
        this.initialized = true;
    }

    onObjectChanged() {
        this.refreshWidgets();
    }

    loadSideBarMenuItems() {
    }

    refreshWidgets() {
        this.refreshCampaignTypeConfigWidget();
        this.refreshCampaignMemberStatusTypeWidget();
        this.refreshCampaignTemplateWidget();
    }

    refreshCampaignTypeConfigWidget() {
        this.campaignTypeConfigWidget = WidgetFactory.createWidgetEntityData(
            'ct.campaign.type.config.widget.basic',
            'Allgemein',
            'ct.CampaignTypeConfig',
            this.objectIdentifier.objectId
        );
    }

    refreshCampaignMemberStatusTypeWidget() {
        this.campaignMemberStatusTypeWidget = WidgetFactory.createWidgetSelectableEntityQl(
            'ct.CampaignMemberStatusType.widget.basic',
            'Mitgliedstatus-Typen',
            'ct.CampaignMemberStatusType',
            'Keine Mitgliedstatus-Typen vorhanden',
            [FilterCriteria.create('e.campaignTypeConfigId', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)],
            [new Sorting('e.sortOrder', false)],
            WidgetDataParam.create('attributeToDisplay', 'e.name')
        );

        this.campaignMemberStatusTypeWidget.functionCallbacks = this.widgetToolbarCreate(
            'campaignTypeConfigDtoId',
            this.objectIdentifier.objectId
        );
    }

    refreshCampaignTemplateWidget() {
        this.campaignTemplateWidget = WidgetFactory.createWidgetSelectableEntityQl(
            'ct.CampaignTemplate.widget.basic',
            'Kampagnenvorlagen',
            'ct.CampaignTemplate',
            'Keine Kampagnenvorlagen vorhanden',
            [FilterCriteria.create('e.campaignTypeConfigId', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)],
            [],
            WidgetDataParam.create('attributeToDisplay', 'e.name')
        );

        this.campaignTemplateWidget.functionCallbacks = this.widgetToolbarCreate(
            'campaignTypeConfigDtoId',
            this.objectIdentifier.objectId
        );
    }

    handleObjectView(object: ObjectIdentifierData | ObjectIdentifier, objectId: string, objectType: string) {
        const event = object as ObjectIdentifierData;
        const id = event.data[objectId];
        const oi = new ObjectIdentifier(objectType, id);
        this.handleObjectViewWidget(oi);
    }

    handleObjectViewWidget(object: ObjectIdentifier, createMode: boolean = false) {
        this.clearWidget();
        this.selectedObject = object;

        if (createMode) {
            this.isCreateMode = true;
        }

        this.objectViewWidget = WidgetFactory.createWidgetEntityData(
            `${object.objectType}.object.view.widget`,
            'Konfiguration',
            object.objectType,
            object.objectId
        );

        this.objectViewWidget.functionCallbacks = this.widgetToolbarCreate(
            'campaignTypeConfigDtoId',
            this.objectIdentifier.objectId
        );

        const defaultDto: DtoDetail = new DtoDetail();
        defaultDto['campaignTypeConfigDtoId'] = this.objectIdentifier.objectId;

        const formControlOverwrite = new MvsFormControlOverwrite();
        formControlOverwrite.addField('campaignTypeConfigDtoId', MvsFormFieldAccessEnum.READ);

        let params: WidgetDataParam[] = [
            WidgetDataParam.create('createDefaultDto', defaultDto),
            WidgetDataParam.create('formControlOverwrite', formControlOverwrite)
        ];

        this.objectWidget = WidgetFactory.createWidgetObject(
            `${object.objectType}.object.view.widget.create`,
            'Object',
            object.objectType,
            object.objectId,
            ...params
        );
    }

    clearWidget() {
        this.isCreateMode = false;
        this.selectedObject = null;
        this.objectViewWidget = null;
        this.objectWidget = null;
    }

    onNavigationItemChange(navigationItem: NavigationItem) {
        this.handleNavigationChange(navigationItem);
    }

    handleNavigationChange(event: NavigationItem) {
        this.clearWidget();
        this.refreshWidgets();
    }

    handleNavigationItemsChange(): void {
        this.onNavigationItems.emit(this.navigationItems);
    }

    widgetToolbarCreate(fieldName: string, fieldValue: number) {
        return {
            onFunctionCreateNew: (): WidgetToolbarCallbackInterface => {
                const dto = new DtoDetail();
                dto[fieldName] = fieldValue;
                const formControlOverwrite = new MvsFormControlOverwrite();
                formControlOverwrite.addField(fieldName, MvsFormFieldAccessEnum.READ);

                return {
                    dto: dto,
                    formControlOverwrite: formControlOverwrite,
                };
            },
        };
    }
}
